import { gql } from '@apollo/client';

export const USER_PUBLISHING_SETTINGS_FRAGMENT = gql`
  fragment UserPublishingSettings on User {
    shouldStoreArticlesOnArweave
  }
`;
